module.exports = __webpack_public_path__ + "media/public/images/social/messanger-hover-6b8966c3129958d3f8efa84f8d02e76b.svg";